import React from 'react';
import { useLegacySearchTheme } from '@atlaskit/navigation-system/experimental/use-legacy-search-theme';
import { ProductSearchInputSkeletonInteractive } from '@atlassian/product-search-dialog/skeleton';

import { useTheme as useThemeDI } from '../../../controllers/theme/main.tsx';
import type { UseThemeType } from '../../../controllers/theme/types.tsx';

type Props = {
	useTheme?: UseThemeType;
	placeholder?: string;
};

// eslint-disable-next-line react-hooks/react-compiler
export const SkeletonInteractive = ({ useTheme = useThemeDI, placeholder }: Props) => {
	/**
	 * The nav3 custom theme object
	 */
	// eslint-disable-next-line react-hooks/react-compiler
	useTheme();
	/**
	 * A nav4 search theme that works with the nav3 theming API
	 */
	const newTheme = useLegacySearchTheme();

	return (
		<ProductSearchInputSkeletonInteractive
			shouldFillContainer
			theme={newTheme}
			placeholder={placeholder || ''}
			stickySearchEnabled
		/>
	);
};
